import React, {useEffect} from 'react'
import { Row, Col} from 'reactstrap';
import {divergentStackedBars} from '../../utils/graphs_facility'


export default ({name, data}) => {

  useEffect(() => {
	  if(data != null){
	    let chart = divergentStackedBars({name: `${name}Values`, data: data, names: {value1: 'value1', value2: 'value2'}})
	    let chart2 = divergentStackedBars({name: `${name}Count`, data: data, names: {value1: 'count1', value2: 'count2'}, reversed: true})

	    return () => {
		    if(chart)
		      chart.dispose()
		    if(chart2)
		      chart2.dispose()
	    }
	  }
	  
  })

  return <div>
	  <div style={{backgroundColor: '#de5c7d', color: 'white', width: '100px', padding: '4px', display: 'inline-block', textAlign: 'center'}}>Scaduto</div>
	  <div style={{backgroundColor: '#52d678', color: 'white', width: '100px', padding: '4px', display: 'inline-block', textAlign: 'center'}}>Non scaduto</div>
	  <Row>

	    
	    <Col xs="6">
		    <div className={`${name}Count`} style={{height: 400}}></div>
        <div className="text-center" style={{paddingRight: '40px'}}><b># aziende</b></div>
	    </Col>
	    <Col xs="6">
		    <div className={`${name}Values`} style={{height: 400}}></div>
        <div className="text-center" style={{paddingLeft: '40px'}}><b>€</b></div>
	    </Col>
	    
	  </Row>
  </div>
}

